"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patterns = void 0;
var emoji_regex_1 = __importDefault(require("emoji-regex"));
exports.patterns = [
    /[\u1100-\u11FF]/g,
    /\u2028/g,
    /\u000b/g,
    /\u36c8/g,
    emoji_regex_1.default(),
    /[\u2300-\u23FF]/g,
    /[\u2400-\u243F]/g,
    /[\u2440-\u245F]/g,
    /[\u2600-\u26FF]/g,
    /[\u2700-\u27BF]/g,
    /[\u3190-\u319F]/g,
    /[\u3300-\u33FF]/g,
    /(\ud83c[\ud000-\udfff])/g,
    /(\ud83d[\ud000-\udfff])/g,
];
//# sourceMappingURL=patterns.js.map